import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { constantsData, statusTypesData, urlsData } from "@/data";
import { editMemberMutation } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useEditMember = (id, groupId) => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [editMemberAction, { loading }] = useMutation(editMemberMutation);

    const {
        members: { url: membersRouteUrl },
        url: groupsRouteUrl,
    } = urlsData.routes.groups;

    const editMember = async ({ email }) => {
        try {
            await editMemberAction({
                onCompleted: () => {
                    navigate(
                        groupId ? `${groupsRouteUrl}/${groupId}${membersRouteUrl}` : groupsRouteUrl + membersRouteUrl,
                    );

                    dispatch(
                        openAlert(
                            t("messages.editMsgs.success", {
                                entity: groupId ? t("groups.members.groupMember") : t("groups.members.entity"),
                            }),
                            statusTypesData.success,
                        ),
                    );
                },
                variables: {
                    data: {
                        email: { set: email },
                    },
                    where: { id },
                },
            });
        } catch (err) {
            displayErrorHandler(
                err.message === constantsData.failedToFetch ? t("messages.networkFailure") : err.message,
                dispatch,
                openAlert,
            );
        }
    };

    return {
        editMember,
        loading,
    };
};

export default useEditMember;
